import * as Yup from 'yup';

export const assistantDefinitionSchema = Yup.object().shape({
  assistantName: Yup.string().required('Assistant Name is required'),
  personality: Yup.string().required('Personality is required'),
  language: Yup.string().required('Language is required'),
  voice: Yup.object().shape({
    name: Yup.string().required('Voice is required'),
    _id: Yup.string().required('Voice ID is required'),
    provider: Yup.string().required('Voice provider is required'),
    accent: Yup.string().required('Voice accent is required'),
  }),
  timezone: Yup.string().required('Timezone is required'),
});
